
import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { useFormField } from "./hooks/useFormField"

const FormControl = React.forwardRef<
  React.ElementRef<typeof Slot>,
  React.ComponentPropsWithoutRef<typeof Slot>
>(({ ...props }, ref) => {
  // Add safety check to avoid using FormField outside of a form
  try {
    const { error, formItemId, formDescriptionId, formMessageId } = useFormField()
    return (
      <Slot
        ref={ref}
        id={formItemId}
        aria-describedby={
          !error
            ? `${formDescriptionId}`
            : `${formDescriptionId} ${formMessageId}`
        }
        aria-invalid={!!error}
        {...props}
      />
    )
  } catch (e) {
    return <Slot ref={ref} {...props} />
  }
})
FormControl.displayName = "FormControl"

export { FormControl }
